import http from './api'
import { Restaurant } from '../types/restaurant'

export interface CreateRestaurantData {
  name: string
  restaurantType: string
  cuisineIds: string[]
}

class RestaurantService {
  async getUserRestaurants(): Promise<Restaurant[]> {
    const response = await http.get('/restaurants')
    return response.data
  }

  async getRestaurant(id: string): Promise<Restaurant> {
    const response = await http.get(`/restaurants/${id}`)
    return response.data
  }

  async createRestaurant(data: CreateRestaurantData): Promise<Restaurant> {
    const response = await http.post('/restaurants', data)
    return response.data
  }

  async updateRestaurant(id: string, data: Partial<CreateRestaurantData>): Promise<Restaurant> {
    const response = await http.patch(`/restaurants/${id}`, data)
    return response.data
  }

  async deleteRestaurant(id: string): Promise<void> {
    await http.delete(`/restaurants/${id}`)
  }

  async joinRestaurant(restaurantId: string): Promise<void> {
    await http.post(`/restaurants/${restaurantId}/join`)
  }

  async leaveRestaurant(restaurantId: string): Promise<void> {
    await http.post(`/restaurants/${restaurantId}/leave`)
  }
}

const restaurantService = new RestaurantService()
export default restaurantService
